import { toNumber } from '../../core/utils/helperFunc';
import { mapItem } from '../orderTracking/mapper';
import { fromBeDemand, fromBeEvent, fromBeReason, fromBeStatus } from './complainEnums';

// Đổi response REST về đúng shape GraphQL getComplain từng trả, để ComplainDetail đọc như cũ.
// Enum về giá trị cũ không tiền tố để các hàm convert…Method trong ReviewComplain/constant.js vẫn dịch được.
export const mapComplain = (response) => {
  const complain = response?.complain;
  // BE trả `{}` (không có khoá complain) khi đơn chưa có khiếu nại nào.
  if (!complain) return null;

  return {
    // Thiếu id thì màn xem hiện '- -' ở chỗ mã yêu cầu.
    id: complain.id,
    code: complain.orderCode,
    status: fromBeStatus(complain.status),
    reason: fromBeReason(complain.reason),
    demand: fromBeDemand(complain.demand),
    description: complain.description,
    total: toNumber(complain.total),
    paymentMethod: complain.paymentMethod,
    attachmentURLs: complain.attachmentUrls || [],
    createdAt: complain.createdAt,
    complainEvents: (complain.events || []).map((event) => ({
      event: fromBeEvent(event?.eventType),
      createdAt: event?.createdAt,
    })),
    items: (complain.items || []).map(mapItem),
  };
};
